module.exports = { id: "safety", url: "/build/app/img/symbols.svg#safety", viewBox: "", toString: function() { return this.url; } };